import { CSSProperties } from "react";
import { TechMultiplePlatformSectionType } from "../../../utility/types/generaTypes";
import TechMultiplePlatformCard from "../techMultiplePlatformCard/TechMultiplePlatformCard";
import "./TechMultiplePlatformSection.css";

type TechMultiplePlatformSectionProps = {
  TechMultiplePlatformData: TechMultiplePlatformSectionType;
  style?: CSSProperties;
};

const TechMultiplePlatformSection = ({
  TechMultiplePlatformData,
  style,
}: TechMultiplePlatformSectionProps) => {
  return (
    <section style={style}>
      <div className="app_section ">
        <div className="appSection_header_container">
          <h1 className="section_title">{TechMultiplePlatformData.title}</h1>
          <p className="section_description">
            {TechMultiplePlatformData.description}
          </p>
        </div>
        <div className="techMultiplePlatformCards_container">
          {TechMultiplePlatformData.data.map((TechMultiplePlatform, index) => (
            <TechMultiplePlatformCard
              key={"TechMultiplePlatformCard" + index}
              TechMultiplePlatform={TechMultiplePlatform}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechMultiplePlatformSection;
